import { ChargeTransactionsForGroup } from "@app/core";

export class InvoiceChargesTenants {

  accessCards: ChargeTransactionsForGroup[];
  meetingRooms: ChargeTransactionsForGroup[];
  facilityAndMaintenance: ChargeTransactionsForGroup[];
  specialService: ChargeTransactionsForGroup[];
  others: ChargeTransactionsForGroup[];



}



// WEBPACK FOOTER //
// ./src/app/core/models/invoice-charges-tenants.ts